module.exports = __webpack_public_path__ + "media/images/401-play-logo-big-white--e114f39c605c4cb0d0683ef0ed1a4f1f.png";